import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  title: string
  description?: string
  /** Right-aligned controls, e.g. "New onboarding". */
  actions?: ReactNode
}

const PageHeaderComponent = ({ title, description, actions }: Props) => {
  return (
    <div css={tw`mb-6 flex shrink-0 flex-row items-start justify-between gap-4`}>
      <div css={tw`flex flex-col gap-1`}>
        <Typography variant="h2">{title}</Typography>
        {description ? (
          <Typography variant="body2" css={tw`text-shades-500`}>
            {description}
          </Typography>
        ) : null}
      </div>
      {actions ? <div css={tw`flex shrink-0 flex-row gap-2`}>{actions}</div> : null}
    </div>
  )
}

export const PageHeader = memo(PageHeaderComponent)
